// Platform-neutral storage — web uses localStorage.
// Same keys as mobile for cross-platform session compatibility.

export const KEYS = {
  accessToken: 'allviews.accessToken',
  refreshToken: 'allviews.refreshToken',
  pendingJoinToken: 'allviews.pendingJoinToken',
  pendingJoinCode: 'allviews.pendingJoinCode',
};

export const storage = {
  get(key) {
    try { return localStorage.getItem(key); } catch { return null; }
  },
  set(key, value) {
    try { localStorage.setItem(key, value); } catch { /* ignore */ }
  },
  remove(key) {
    try { localStorage.removeItem(key); } catch { /* ignore */ }
  },
};
